import { call, put } from 'redux-saga/effects'
import { API_RESPONSE_TYPE, IApiResponse } from 'shared/constants'
import { Action } from 'infra/types'
import {
  addEligibleInventoryItems,
  filterByLabelKeyApi,
  removeEligibleInventoryItems
} from 'services/Api/StaffLinkApiFolder/api'
import { addAutoFadeNotification } from 'pages/Notification/Notification.actions'
import { NotificationType } from 'pages/Notification/Notification.types'
import { setCreateNewListDrawerAction } from 'state/new-summary/root-drawers/create-new-list/create-new-list.actions'
import { fetchOrderSettingInventoryIds } from 'state/new-summary/list/list.effect'
import { updateInventoryItemsToOrderSettingListAction } from 'state/new-summary/list/collection-list.actions'
import { IFilterByLabelKeyPayload } from 'state/new-summary/root-drawers/tag-filter/tag-filter.types'

export function* handleAssignedInventoriesEffects(
  action: Action<{ newItemIds: string[]; removedItemIds: string[]; listId: string }>
) {
  const { newItemIds, listId, removedItemIds } = action.payload
  if (newItemIds.length > 0) {
    const addItemsPayload = {
      inventory_item_ids: newItemIds,
      list_id: listId
    }
    const addItemsResponse: IApiResponse = yield call(addEligibleInventoryItems, addItemsPayload)
    if (addItemsResponse.type === API_RESPONSE_TYPE.FAILURE) {
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: 'Error while assigning Inventory. Try again!'
        })
      )
    } else if (addItemsResponse.type === API_RESPONSE_TYPE.SUCCESS) {
      yield put(
        addAutoFadeNotification({
          type: NotificationType.SUCCESS,
          bodyText: 'New items have been Successfully Assigned!'
        })
      )
    }
  }
  if (removedItemIds.length > 0) {
    const removeItemsPayload = {
      inventory_item_ids: removedItemIds,
      list_id: listId
    }
    const removedItemsResponse: IApiResponse = yield call(
      removeEligibleInventoryItems,
      removeItemsPayload
    )
    if (removedItemsResponse.type === API_RESPONSE_TYPE.FAILURE) {
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: 'Error while removing items from Inventory. Try again!'
        })
      )
    } else if (removedItemsResponse.type === API_RESPONSE_TYPE.SUCCESS) {
      yield put(
        addAutoFadeNotification({
          type: NotificationType.SUCCESS,
          bodyText: 'Some items have been Successfully UnAssigned!'
        })
      )
    }
  }
  yield put(setCreateNewListDrawerAction({ id: 'showAssignedInventories', value: false }))
  const fetchOrderSettingInventoryItemIdsResponse: string[] = yield call(
    fetchOrderSettingInventoryIds,
    {
      listId
    }
  )
  yield put(
    updateInventoryItemsToOrderSettingListAction({
      inventoryItemIds: fetchOrderSettingInventoryItemIdsResponse || []
    })
  )
}

// export function* setFilterEntityByLabelKeyValsEffects (
//   action: Action<IFilterByLabelKeyPayload>
// ) {
//   const payload = action.payload
//   const response: IApiResponse = yield call(filterByLabelKeyApi, payload)
//   if (response.type === API_RESPONSE_TYPE.FAILURE) {
//     yield put(
//       addAutoFadeNotification({
//         type: NotificationType.ERROR,
//         bodyText: 'Error while applying filter. Try again!'
//       })
//     )
//   }
//   yield put(saveSelectedLabelKeyEntities({ id: 'showAssignedInventories', value: false }))
// }
